import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import NavigationOptions from './PresentationData'
import styled from 'styled-components'

import BackToPortal from '../../../../../components/BackToPortal'

const IntroParagraph = styled.div`
    > p {
        margin-bottom: 10px;
    }
`

const PresentationSidebar = ({ graph }) => {
    const [graphData, setGraphData] = useState({})

    useEffect(() => {
        const activeIndex = NavigationOptions.map((p) => p.link).indexOf(graph)
        setGraphData(NavigationOptions[activeIndex])
    }, [graph])

    const { title, sidebarDescription } = graphData

    return (
        <>
            <div className="border-box">
                <h2>{title}</h2>
                <IntroParagraph>{sidebarDescription}</IntroParagraph>
            </div>

            <ul className="button-list">
                <li>
                    <Link to="/clients" className="btn arrow-btn-left">
                        BACK TO CLIENTS<span></span>
                    </Link>
                </li>
                <li>
                    <BackToPortal />
                </li>
            </ul>
        </>
    )
}

export default PresentationSidebar
